module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYCAYAAACbU/80AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAA3SURBVHgB7dRBDQAgFMPQfYJQUAZOYajYgb6kFlrHFNQU1t0WgJ+VRzgUVKzYTQH42TvhUhArvufLFALgfqRIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/website/mb-menu.png
// module id = 219
// module chunks = 0 1 2